import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { mediaUrl } from "@/lib/api";

export const Hero = ({ texts }) => {
  const wrapRef = useRef(null);
  const imgRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    const onMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      if (imgRef.current) imgRef.current.style.transform = `translate(${x * -14}px, ${y * -10}px) scale(1.05)`;
      if (titleRef.current) titleRef.current.style.transform = `translate(${x * 18}px, ${y * 12}px)`;
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  const marqueeText = texts.hero_marquee || "8.2M TAKİPÇİ ✦ 431.5M BEĞENİ ✦ ÖDCFC ✦ CELLAT AİLESİ ✦ 36 ✦";
  const items = Array(4).fill(marqueeText);

  return (
    <section ref={wrapRef} data-testid="hero-section" className="relative h-[100svh] overflow-hidden flex items-center justify-center bg-[#0A0A0A]">
      <div className="absolute inset-0 overflow-hidden">
        <img
          ref={imgRef}
          src={mediaUrl(texts.hero_image)}
          alt="Özgür Deniz Cellat portre"
          className="w-full h-full object-cover img-duotone opacity-40 transition-transform duration-300 ease-out"
          style={{ transform: "scale(1.05)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-transparent to-[#0A0A0A]" />
      </div>

      <div className="relative z-10 text-center px-6">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 1 }}
          className="text-[#C1121F] tracking-[0.5em] text-xs md:text-sm mb-4 uppercase"
        >
          Özgür Deniz Cellat — @cellat36
        </motion.p>
        <h1
          ref={titleRef}
          data-testid="hero-title"
          className="font-blackletter leading-none text-[#EDEDEA] transition-transform duration-300 ease-out select-none"
          style={{ fontSize: "clamp(5rem, 18vw, 20rem)", textShadow: "0 0 80px rgba(139,0,0,0.4)" }}
        >
          {["C", "E", "L", "L", "A", "T"].map((l, i) => (
            <motion.span
              key={i}
              className="inline-block"
              initial={{ opacity: 0, y: 60, filter: "blur(8px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ delay: 0.2 + i * 0.08, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            >
              {l}
            </motion.span>
          ))}
        </h1>
        <motion.p
          data-testid="hero-tagline"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.8 }}
          className="mt-6 text-base md:text-lg text-[#A3A3A3] max-w-xl mx-auto"
        >
          {texts.hero_tagline || "Türkiye'nin en sadık kitlesi. Tek bir isim."}
        </motion.p>
      </div>

      <motion.div
        className="absolute bottom-24 md:bottom-28 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2"
        animate={{ y: [0, 12, 0] }}
        transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
      >
        <svg width="16" height="34" viewBox="0 0 16 34" fill="none" aria-hidden="true">
          <path d="M8 0 C 8 8, 13 10, 13 16 C 13 22, 3 24, 3 29 L 8 34 L 13 29" stroke="#8B0000" strokeWidth="1.5" fill="none" />
        </svg>
        <span className="text-[10px] tracking-[0.4em] text-[#525252] uppercase">Kaydır</span>
      </motion.div>

      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-b border-[#262626] bg-[#0A0A0A]/80 backdrop-blur-sm py-3 overflow-hidden">
        <div className="marquee-track" data-testid="hero-marquee">
          {items.map((t, i) => (
            <span key={i} className="whitespace-nowrap text-sm md:text-base tracking-[0.3em] text-[#EDEDEA] px-4 uppercase">
              {t}&nbsp;✦&nbsp;
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
